import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { CoLineBackground } from "../styles";
import Logo from "../assets/image/mobile/img_coline_info_007_3.png";
import CryptoJS from "crypto-js";

const Direct = () => {
  const [isLoading, setLoading] = useState(true);
  const loadingTxt = useMemo(() => "即將為您開啟桌面App，請稍候...", []);
  const finishTxt = useMemo(
    () => "您尚未登入CoLine，請先下載並登入後再次點擊邀請連結加入。",
    []
  );

  const handleRedirect = () => {
    const params = new URLSearchParams(window.location.search);
    const enc = params.get("enc");
    const str = decodeURIComponent(enc);
    const decoded = CryptoJS.AES.decrypt(str, "Co!ineXW@b").toString(
      CryptoJS.enc.Utf8
    );

    const [gi, gn, uuid] = decoded.split(":");
    const allInfo = !!gi && !!gn && !!uuid;
    // 開啟CoLine或導向CoLine下載頁面
    const electronDL = `CoLine://open${
      allInfo ? `?gi=${gi}&gn=${gn}&uuid=${uuid}` : ""
    }`;

    const a = document.createElement("a");
    a.href = electronDL;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();

    setTimeout(() => setLoading(!document.hasFocus()), 1000);
    // setLoading(document.hasFocus());
  };

  useEffect(handleRedirect, []);

  return (
    <div style={CoLineBackground}>
      <img alt="CoLine" src={Logo} />
      <p>{isLoading ? loadingTxt : finishTxt}</p>
      {!isLoading && <Link to="/download">前往下載</Link>}
    </div>
  );
};

export default Direct;
